<template>

  <div class="gao-list">

<div class="gao-listall">


      <div  class="gao-content">
          <div v-for="(item,index) in gaolistdata" :key="item.id" class="gao-content-s">
          <!-- 日期 -->
          <div class="riqi">
              <span class="rqy">{{rq[index]}}</span> <br>
              <span class="rqx"></span> <br>
              <span class="rqn">{{year[index]}}</span>
          </div>
          <!-- 内容 -->
          <div  @click="gengduo(index)" class="gaotxt">
              <p class="gaop1">{{gaolistdata[index].title}}</p>
              <p class="gaop2">{{gaolistdata[index].message}}</p>
                                 
          </div>
             <!-- 更多 -->  
              <div @click="gengduo(index)" class="gengduo">
                  <a href="###"><span>更多</span></a>  <br>
                  <img src="../assets/jiantou.png" alt="">
              </div>
          </div>      
      

           <div class="gao-list-page">
              <el-pagination
                background
                layout="prev, pager, next"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentpage"
                :total="total"
                :page-size="perpg"
              >
              </el-pagination>
            </div>  
      </div>
    
</div>
 <botTom></botTom>
  </div>
    


</template>

<script>
import Gaolist from "../css/Gaolist.css"
import botTom from "./BotTom"
import axios from 'axios'
export default {
data(){
    return{
        gaolistdata:[],
        rq:[],
        year:[],
          commentdata: [], //评论数据
      currentpage: 1, //当前页数
      perpg: 3, //一页显示的数据数
      total: 5, //总数据
    }
},
  mounted(){
 this.onLoad();
},
methods: {
    handleSizeChange(val) {
      this.perpg = val;
      // console.log(this.perpg, "一页显示的数据");
    },
        //分页
    handleCurrentChange(val) {
      this.currentpage = val;
      this.onLoad();
   
    },
     // 时间
 timestampToTime(timestamp) {
    var date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
 
  var   M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
  var   D = this.change(date.getDate()) + '';
  var   h = this.change(date.getHours()) + ':';
  var   m = this.change(date.getMinutes()) + ':';
  var   s = this.change(date.getSeconds());
    return M+'-'+D;
},
     // 时间
 timestampToTimesa(timestamp) {
    var date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
  var  Y = date.getFullYear() + '';
  var   M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
  var   D = this.change(date.getDate()) + '';
  var   h = this.change(date.getHours()) + ':';
  var   m = this.change(date.getMinutes()) + ':';
  var   s = this.change(date.getSeconds());
    return Y;
},
change(t) {
    if (t < 10) {
        return "0" + t;
    } else {
        return t;
    }
 
},
    onLoad(){

     
      let fas = new window.FormData();
     

      fas.append('page',this.currentpage);
      axios({
  method:'get',
  url:this.$apiUrl+'/index.php/index/notice',
  // timeout: 1000,
}).then(res=> {
this.gaolistdata = res.data.data.data;
for (let index = 0; index < this.gaolistdata .length; index++) {
      this.rq.push(this.timestampToTime(this.gaolistdata[index].create_time))
this.year.push(this.timestampToTimesa(this.gaolistdata[index].create_time))
}
  //分页
   this.perpg = res.data.data.per_page;//一页显示的数据
          this.total = res.data.data.total; //总数据数
}).catch(error =>{
    console.log(error);
})
},
gengduo(index){
 

       this.$router.push({path:"/GongGaoson"});
    //   console.log(this.gaolistdata[index].id);
      sessionStorage.setItem('xinwid',this.gaolistdata[index].id);
}
},
components:{
botTom,
}
}
</script>




// WEBPACK FOOTER //
// src/components/GaoList.vue